import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import router from '@/router';
import { getRecentThirtyDaysApi, getHoursApi, getDaysApi, getMonthApi, getYearApi, getInvsApi } from '../../api';
import { dbDataHandle } from '../function/common/index';
import mainStore from '../index';
var defaultSeries = [{
  data: [],
  type: 'column',
  name: '發電量',
  yAxis: 0,
  color: '#7cb5ec',
  tooltip: {
    valueSuffix: ' (kWh)'
  }
  // showInLegend: false // 不顯示圖例
}, {
  data: [],
  type: 'line',
  name: '日照量',
  yAxis: 1,
  color: '#434348',
  tooltip: {
    valueSuffix: ' (kWh/m²)'
  }
}, {
  data: [],
  type: 'spline',
  dataLabels: {
    format: '{y} %'
  },
  name: '發電效率',
  yAxis: 2,
  color: '#90ed7d',
  tooltip: {
    valueSuffix: ' (%)'
  },
  showInLegend: true,
  dashStyle: 'shortdashdotdot',
  clip: false
}, {
  data: [],
  type: 'spline',
  dataLabels: {
    // format: '{y} °C'
  },
  name: '模組溫度',
  yAxis: 3,
  color: '#f7a35c',
  tooltip: {
    valueSuffix: ' (°C)'
  },
  dashStyle: 'shortdot'
}, {
  data: [],
  type: 'line',
  name: '發電收入',
  yAxis: 4,
  color: '#8085e9',
  tooltip: {
    valueSuffix: ' (NTD)'
  }
}];
var state = {
  groupNumber: '',
  siteInfoDetailDownloadData: [],
  siteInfoDetailDownloadField: [],
  uluru: {
    lat: 23.927734,
    lng: 121.074844
  },
  weatherLonAndLat: {
    lon: '',
    lat: ''
  },
  demoContent: ['(展示案場)', '2020-01-01', '12345678', '東西向', '北區', '台灣', '桃園市', '桃園區', 'ABCD_0123456', '1234 Pcs', '30°', '外線高壓併，3相3線 11.4kV', '桃園市桃園區', '進金生能源服務', '121.074844', '23.927734', '8', '2020-01-01'],
  siteInfoValue: [['案場 APP 名稱', 'SiteMonitor.exe']],
  siteInfoDetailChartOptions: {
    chart: {
      height: 280,
      backgroundColor: 'transparent',
      alignTicks: false
      // marginLeft: 40,
      // marginRight: 30
    },
    title: '',
    tooltip: {
      shared: true
    },
    credits: {
      enabled: false
    },
    legend: {
      // align: 'right',
      // layout: 'vertical',
      // verticalAlign: 'middle'
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      margin: 30,
      labelFormat: '{name} {tooltipOptions.valueSuffix}'
    },
    yAxis: [{
      title: {
        // text: '發電量 (kWh)'
        text: ''
      },
      labels: {
        enabled: false // 顯示刻度數字
      },
      gridLineWidth: 0 // 刻度橫線粗細，與刻度數字是獨立調整
    }, {
      title: {
        // text: '日照量 (kWh/m²)'
        text: ''
      },
      labels: {
        enabled: false
      },
      gridLineWidth: 0
    }, {
      title: {
        // text: '發電效率 (%)'
        text: ''
      },
      max: 100,
      min: 0,
      tickInterval: 50,
      // 單位間距
      labels: {
        enabled: false
      },
      gridLineWidth: 0
      // opposite: true
    }, {
      title: {
        // text: '模組溫度 (°C)'
        text: ''
      },
      max: 80,
      min: 0,
      labels: {
        enabled: false
      },
      gridLineWidth: 0
      // opposite: true
    }, {
      title: {
        // text: '發電收入 (NTD)'
        text: ''
      },
      labels: {
        enabled: false
      },
      gridLineWidth: 0
    }],
    xAxis: [{
      categories: [],
      crosshair: true,
      // index: 0,
      isX: true,
      gridLineWidth: 0
    }],
    plotOptions: {
      series: {
        // ALL series
        dataLabels: {
          enabled: true
        }
      }
      // column: { // ALL column
      //   dataLabels: {
      //     enabled: true
      //   }
      // },
      // spline: { // ALL spline
      //   dataLabels: {
      //     enabled: true,
      //     // format: '{x} \t {y} mm'
      //     format: '{y} %'
      //   }
      // }
    },
    series: [],
    lang: {
      noData: '現在沒有資料'
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      }
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
            y: 0
          }
        }
      }]
    }
  },
  voltages: {
    accVal: 0,
    // 累積發電量
    todayVal: 0 // 今日發電量
  },
  // 即時資訊
  realTimeGrid: {
    irr: 0,
    // 目前日照強度 w/m²
    eToday: 0,
    // 今日日照量 kWh/m²
    peak: 0,
    // 今日峰瓩值 kWh/kWp
    pr: 0,
    // 今日 PR %
    lowCurrent: 0,
    // 低壓功率 kW
    highCurrent: 0,
    // 高壓功率 kW
    moduleTemp: 0,
    // 模組溫度 °C
    envTemp: 0,
    // 環境溫度 °C
    anemometer: 0,
    // 即時風速 m/s
    windVane: 0,
    // 即時風向 °
    waterLevel: 0 // 即時水位值 m
  },
  weatherData: {
    temp: 0,
    desc: '',
    iconUrl: ''
  },
  capacity: [],
  resError: false,
  resChoose: '',
  showPR: false,
  // 圖表顯示發電效率
  showRevenue: false,
  // 圖表顯示發電收入
  didoStatus: []
};
var mutations = {
  SET_WEATHER_DATA: function SET_WEATHER_DATA(state, payload) {
    state.weatherData = payload;
  },
  SET_VOLTAGES: function SET_VOLTAGES(state, payload) {
    state.voltages = payload;
  },
  SET_REALTIME_GRID: function SET_REALTIME_GRID(state, payload) {
    state.realTimeGrid = _objectSpread(_objectSpread({}, state.realTimeGrid), payload);
  },
  SET_DIDO_STATUS: function SET_DIDO_STATUS(state, payload) {
    state.didoStatus = payload;
  },
  MERGE_DIDO_STATUS: function MERGE_DIDO_STATUS(state, deviceStatus) {
    // WS dido 為單一 pin 增量更新，合併進該 device 已知腳位，保留其餘 pin 與其他 device
    var idx = state.didoStatus.findIndex(function (d) {
      return d.name === deviceStatus.name;
    });
    if (idx === -1) {
      state.didoStatus = [].concat(_toConsumableArray(state.didoStatus), [deviceStatus]);
    } else {
      state.didoStatus.splice(idx, 1, _objectSpread(_objectSpread({}, state.didoStatus[idx]), deviceStatus));
    }
  },
  RESET_SITE_INFO_CHART: function RESET_SITE_INFO_CHART(state) {
    var options = state.siteInfoDetailChartOptions;
    // chart margin
    options.chart.marginRight = 30;
    options.chart.marginLeft = 30;
    options.xAxis[0].categories = [];
    options.series = JSON.parse(JSON.stringify(defaultSeries));
    if (!state.showPR) options.series[2].showInLegend = false;
    if (!state.showRevenue) options.series[4].showInLegend = false;
  },
  SET_YMAX: function SET_YMAX(state, payload) {
    if (payload) {
      var payloadData = payload.data;
      var acpYmax = Math.max.apply(Math, _toConsumableArray(payloadData.map(function (p) {
        return p.acp ? p.acp.all || 0 : 0;
      }))) * 1.3;
      state.siteInfoDetailChartOptions.yAxis[0].max = acpYmax;
      var irrArray = [];
      payloadData.forEach(function (item) {
        var IRR = _typeof(item.IRR) === 'object' && item.IRR !== null ? dbDataHandle(item.IRR.avg) : dbDataHandle(item.IRR);
        irrArray.push(IRR);
      });
      var irrDataMax = Math.max.apply(Math, irrArray);
      var irrYmax = irrDataMax > 80 ? irrDataMax * 1.2 : 80; // 同模組溫度 max
      state.siteInfoDetailChartOptions.yAxis[1].max = irrYmax;
    }
  },
  SET_DOWNLOAD_DATA: function SET_DOWNLOAD_DATA(state, payload) {
    state.siteInfoDetailDownloadField = [];
    state.siteInfoDetailDownloadData = [];
    state.siteInfoDetailDownloadField = ['name'];
    state.siteInfoDetailDownloadField = state.siteInfoDetailDownloadField.concat(state.siteInfoDetailChartOptions.xAxis[0].categories);
    payload.series.forEach(function (x) {
      var obj = {
        name: x.name
      };
      state.siteInfoDetailDownloadData.push(obj);
    });
    payload.xAxis[0].categories.forEach(function (x, idx) {
      state.siteInfoDetailDownloadData.forEach(function (y, yIdx) {
        // 空一格 fix 年歷史 name 標題應位於最左側 (obj key 順序問題)
        y["".concat(x, " ")] = payload.series[yIdx].data[idx];
      });
    });
  },
  referenceChartOptions: function referenceChartOptions(state, payload) {
    Object.assign(state.siteInfoDetailChartOptions, payload);
  }
};
var actions = {
  getWeather: function getWeather(_ref) {
    var state = _ref.state,
      commit = _ref.commit;
    var siteName = router.currentRoute.query.siteName;
    var lon = state.weatherLonAndLat.lon;
    var lat = state.weatherLonAndLat.lat;
    if (siteName && lon && lat) {
      var urlProtocol = process.env.NODE_ENV === 'development' ? 'http' : 'https';
      var params = new URLSearchParams();
      params.append('apikey', process.env.VUE_APP_WEATHER_API_KEY);
      params.append('units', 'metric');
      params.append('lang', 'zh_TW');
      params.append('format', 'JSON');
      params.append('lon', lon);
      params.append('lat', lat);
      axios.get("".concat(urlProtocol, "://api.openweathermap.org/data/2.5/weather?").concat(params.toString())).then(function (res) {
        var _res$data, _res$data$main, _res$data2, _res$data2$weather, _res$data2$weather$, _res$data3, _res$data3$weather, _res$data3$weather$;
        var weatherInfo = {
          temp: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$main = _res$data.main) === null || _res$data$main === void 0 ? void 0 : _res$data$main.temp,
          desc: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$weather = _res$data2.weather) === null || _res$data2$weather === void 0 ? void 0 : (_res$data2$weather$ = _res$data2$weather[0]) === null || _res$data2$weather$ === void 0 ? void 0 : _res$data2$weather$.description,
          iconUrl: "".concat(urlProtocol, "://openweathermap.org/img/wn/").concat((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$weather = _res$data3.weather) === null || _res$data3$weather === void 0 ? void 0 : (_res$data3$weather$ = _res$data3$weather[0]) === null || _res$data3$weather$ === void 0 ? void 0 : _res$data3$weather$.icon, "@2x.png")
          // iconUrl: `${urlProtocol}://openweathermap.org/img/w/${res.data.weather[0].icon}.png`
        };
        commit('SET_WEATHER_DATA', weatherInfo);
      }).catch(function (err) {
        return console.log('getWeather error: ', err);
      });
    }
  },
  // 最近 30 天
  getChartByRecentThirtyDays: function getChartByRecentThirtyDays(_ref2, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var state, commit, fId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = _ref2.state, commit = _ref2.commit;
              fId = payload.fId;
              _context.next = 4;
              return getRecentThirtyDaysApi(fId).then(function (data) {
                var _data$data;
                if (!(data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.success)) {
                  state.resChoose = '最近30天';
                  state.resError = true;
                } else {
                  var _info$;
                  state.resError = false;
                  state.showPR = true;
                  state.showRevenue = false;

                  // get price from store
                  var info = mainStore.state.factoryInfo.filter(function (f) {
                    return f.factoryId === router.currentRoute.query.fid;
                  });
                  var unitPrice = (_info$ = info[0]) === null || _info$ === void 0 ? void 0 : _info$.informations.unitPrice;
                  var price = 0;
                  if (unitPrice && unitPrice !== '-') {
                    price = unitPrice * 1;
                    state.showRevenue = true;
                  }

                  // 清空
                  commit('RESET_SITE_INFO_CHART');
                  // set yMax
                  commit('SET_YMAX', data === null || data === void 0 ? void 0 : data.data);

                  // set chart margin (讓 x 軸日期不會被擠壓)
                  state.siteInfoDetailChartOptions.chart.marginLeft = 40;
                  state.siteInfoDetailChartOptions.chart.marginRight = 30;

                  // data push
                  data.data.data = data === null || data === void 0 ? void 0 : data.data.data.sort(function (a, b) {
                    return a.date - b.date;
                  });
                  data.data.data.forEach(function (item) {
                    if (item.acp !== undefined || item.IRR !== undefined || item.pr !== undefined || item.PVTemp !== undefined) {
                      var time = item.date;
                      var acp = item.acp !== null ? dbDataHandle(item.acp.all) : 0;
                      var IRR = _typeof(item.IRR) === 'object' && item.IRR !== null ? dbDataHandle(item.IRR.avg) : dbDataHandle(item.IRR);
                      // const PR = calculatePR(this.state.capacity, item.acp, IRR)
                      var PR = _typeof(item.pr) === 'object' && item.pr !== null ? dbDataHandle(Math.floor(item.pr.all * 100)) : null;
                      var PVTemp = item.PVTemp !== null ? dbDataHandle(item.PVTemp) : null;
                      var revenue = dbDataHandle(acp * price, 0);
                      state.siteInfoDetailChartOptions.xAxis[0].categories.push(time);
                      state.siteInfoDetailChartOptions.series[0].data.push(acp);
                      state.siteInfoDetailChartOptions.series[1].data.push(IRR);
                      state.siteInfoDetailChartOptions.series[2].data.push(PR);
                      state.siteInfoDetailChartOptions.series[3].data.push(PVTemp);
                      if (state.showRevenue) {
                        state.siteInfoDetailChartOptions.series[4].data.push(revenue);
                      }
                    }
                  });

                  // revenue Ymax
                  var revenueDataMax = Math.max.apply(Math, _toConsumableArray(state.siteInfoDetailChartOptions.series[4].data));
                  state.siteInfoDetailChartOptions.yAxis[4].max = revenueDataMax === 0 ? 100 : null; // auto calculated

                  commit('SET_DOWNLOAD_DATA', state.siteInfoDetailChartOptions);
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // 時歷史
  getChartByHour: function getChartByHour(_ref3, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var state, commit, todayDate, fId, siteName;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = _ref3.state, commit = _ref3.commit;
              todayDate = payload.todayDate, fId = payload.fId, siteName = payload.siteName;
              _context2.next = 4;
              return getHoursApi(todayDate, fId, siteName).then(function (data) {
                var _data$data2;
                if (!(data !== null && data !== void 0 && (_data$data2 = data.data) !== null && _data$data2 !== void 0 && _data$data2.success)) {
                  state.resChoose = '時歷史';
                  state.resError = true;
                } else {
                  var _info$2;
                  state.resError = false;
                  state.showPR = false;

                  // get price from store
                  var info = mainStore.state.factoryInfo.filter(function (f) {
                    return f.factoryId === router.currentRoute.query.fid;
                  });
                  var unitPrice = (_info$2 = info[0]) === null || _info$2 === void 0 ? void 0 : _info$2.informations.unitPrice;
                  var price = 0;
                  if (unitPrice && unitPrice !== '-') {
                    price = unitPrice * 1;
                    state.showRevenue = true;
                  }

                  // 清空
                  commit('RESET_SITE_INFO_CHART');
                  // set yMax
                  commit('SET_YMAX', data === null || data === void 0 ? void 0 : data.data);

                  // data push
                  data.data.data = data === null || data === void 0 ? void 0 : data.data.data.sort(function (a, b) {
                    return a.hhmm - b.hhmm;
                  });
                  data.data.data.forEach(function (item) {
                    if (parseInt(item.hhmm.substr(0, 2)) >= 5) {
                      if (item.acp !== undefined || item.IRR !== undefined || item.pr !== undefined || item.PVTemp !== undefined) {
                        var time = item.hhmm;
                        var acp = item.acp !== null ? dbDataHandle(item.acp.all) : null; // 發電量
                        var IRR = _typeof(item.IRR) === 'object' && item.IRR !== null ? dbDataHandle(item.IRR.avg) : dbDataHandle(item.IRR);
                        var PVTemp = item.PVTemp ? dbDataHandle(item.PVTemp) : null;
                        // const PR = item.pr !== null ? dbDataHandle(Math.floor(item.pr.all * 100)) : null
                        var revenue = dbDataHandle(acp * price, 0);
                        state.siteInfoDetailChartOptions.xAxis[0].categories.push(time);
                        state.siteInfoDetailChartOptions.series[0].data.push(acp);
                        state.siteInfoDetailChartOptions.series[1].data.push(IRR);
                        // state.siteInfoDetailChartOptions.series[2].data.push(PR)
                        // 暫時filter moduleTemp
                        state.siteInfoDetailChartOptions.series[3].data.push(PVTemp);
                        if (state.showRevenue) {
                          state.siteInfoDetailChartOptions.series[4].data.push(revenue);
                        }
                      }
                    }
                  });

                  // IRR Ymax
                  var irrDataMax = Math.max.apply(Math, _toConsumableArray(state.siteInfoDetailChartOptions.series[1].data));
                  state.siteInfoDetailChartOptions.yAxis[1].max = irrDataMax === 0 ? 100 : irrDataMax * 5;

                  // revenue Ymax
                  var revenueDataMax = Math.max.apply(Math, _toConsumableArray(state.siteInfoDetailChartOptions.series[4].data));
                  state.siteInfoDetailChartOptions.yAxis[4].max = revenueDataMax === 0 ? 100 : null; // auto calculated

                  commit('SET_DOWNLOAD_DATA', state.siteInfoDetailChartOptions);
                }
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  // 日歷史
  getChartByDay: function getChartByDay(_ref4, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var state, commit, thisMon, fId, siteName;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref4.state, commit = _ref4.commit;
              thisMon = payload.thisMon, fId = payload.fId, siteName = payload.siteName;
              _context3.next = 4;
              return getDaysApi(thisMon, fId, siteName).then(function (data) {
                var _data$data3;
                if (!(data !== null && data !== void 0 && (_data$data3 = data.data) !== null && _data$data3 !== void 0 && _data$data3.success)) {
                  state.resChoose = '日歷史';
                  state.resError = true;
                } else {
                  var _info$3;
                  state.resError = false;
                  state.showPR = true;

                  // get price from store
                  var info = mainStore.state.factoryInfo.filter(function (f) {
                    return f.factoryId === router.currentRoute.query.fid;
                  });
                  var unitPrice = (_info$3 = info[0]) === null || _info$3 === void 0 ? void 0 : _info$3.informations.unitPrice;
                  var price = 0;
                  if (unitPrice && unitPrice !== '-') {
                    price = unitPrice * 1;
                    state.showRevenue = true;
                  }

                  // 清空
                  commit('RESET_SITE_INFO_CHART');
                  // set yMax
                  commit('SET_YMAX', data === null || data === void 0 ? void 0 : data.data);

                  // data push
                  data.data.data = data === null || data === void 0 ? void 0 : data.data.data.sort(function (a, b) {
                    return a.date - b.date;
                  });
                  data.data.data.forEach(function (item) {
                    if (item.acp !== undefined || item.IRR !== undefined || item.pr !== undefined || item.PVTemp !== undefined) {
                      var time = item.date;
                      var acp = item.acp !== null ? dbDataHandle(item.acp.all) : null; // 發電量
                      var IRR = _typeof(item.IRR) === 'object' && item.IRR !== null ? dbDataHandle(item.IRR.avg) : dbDataHandle(item.IRR);
                      var PR = _typeof(item.pr) === 'object' && item.pr !== null ? dbDataHandle(Math.floor(item.pr.all * 100)) : null;
                      var PVTemp = item.PVTemp > 0 ? dbDataHandle(item.PVTemp) : null;
                      var revenue = dbDataHandle(acp * price, 0);
                      state.siteInfoDetailChartOptions.xAxis[0].categories.push(time);
                      state.siteInfoDetailChartOptions.series[0].data.push(acp);
                      state.siteInfoDetailChartOptions.series[1].data.push(IRR);
                      state.siteInfoDetailChartOptions.series[2].data.push(PR);
                      state.siteInfoDetailChartOptions.series[3].data.push(PVTemp);
                      if (state.showRevenue) {
                        state.siteInfoDetailChartOptions.series[4].data.push(revenue);
                      }
                    }
                  });

                  // revenue Ymax
                  var revenueDataMax = Math.max.apply(Math, _toConsumableArray(state.siteInfoDetailChartOptions.series[4].data));
                  state.siteInfoDetailChartOptions.yAxis[4].max = revenueDataMax === 0 ? 100 : null; // auto calculated

                  commit('SET_DOWNLOAD_DATA', state.siteInfoDetailChartOptions);
                }
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  // 月歷史
  getChartByMonth: function getChartByMonth(_ref5, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var state, commit, thisYear, fId, siteName;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref5.state, commit = _ref5.commit;
              thisYear = payload.thisYear, fId = payload.fId, siteName = payload.siteName;
              _context4.next = 4;
              return getMonthApi(thisYear, fId, siteName).then(function (data) {
                var _data$data4;
                if (!(data !== null && data !== void 0 && (_data$data4 = data.data) !== null && _data$data4 !== void 0 && _data$data4.success)) {
                  state.resChoose = '月歷史';
                  state.resError = true;
                } else {
                  var _info$4;
                  state.resError = false;
                  state.showPR = true;

                  // get price from store
                  var info = mainStore.state.factoryInfo.filter(function (f) {
                    return f.factoryId === router.currentRoute.query.fid;
                  });
                  var unitPrice = (_info$4 = info[0]) === null || _info$4 === void 0 ? void 0 : _info$4.informations.unitPrice;
                  var price = 0;
                  if (unitPrice && unitPrice !== '-') {
                    price = unitPrice * 1;
                    state.showRevenue = true;
                  }

                  // 清空
                  commit('RESET_SITE_INFO_CHART');
                  // set yMax
                  commit('SET_YMAX', data === null || data === void 0 ? void 0 : data.data);

                  // data push
                  data.data.data = data === null || data === void 0 ? void 0 : data.data.data.sort(function (a, b) {
                    return a.month - b.month;
                  });
                  data.data.data.forEach(function (item) {
                    if (item.acp && (item.acp !== undefined || item.IRR !== undefined || item.pr !== undefined || item.PVTemp !== undefined)) {
                      var time = item.month;
                      var acp = item.acp !== null ? dbDataHandle(item.acp.all) : null; // 發電量
                      var IRR = _typeof(item.IRR) === 'object' && item.IRR !== null ? dbDataHandle(item.IRR.avg) : null; // 日照量
                      // const PR = calculatePR(this.state.capacity, item.acp.all, IRR)
                      var PR = _typeof(item.pr) === 'object' && item.pr !== null ? dbDataHandle(Math.floor(item.pr.all * 100)) : null;
                      var PVTemp = item.PVTemp > 0 ? dbDataHandle(item.PVTemp) : null;
                      var revenue = dbDataHandle(acp * price, 0);
                      state.siteInfoDetailChartOptions.xAxis[0].categories.push(time);
                      state.siteInfoDetailChartOptions.series[0].data.push(acp);
                      state.siteInfoDetailChartOptions.series[1].data.push(IRR);
                      state.siteInfoDetailChartOptions.series[2].data.push(PR);
                      state.siteInfoDetailChartOptions.series[3].data.push(PVTemp);
                      if (state.showRevenue) {
                        state.siteInfoDetailChartOptions.series[4].data.push(revenue);
                      }
                    }
                  });

                  // revenue Ymax
                  var revenueDataMax = Math.max.apply(Math, _toConsumableArray(state.siteInfoDetailChartOptions.series[4].data));
                  state.siteInfoDetailChartOptions.yAxis[4].max = revenueDataMax === 0 ? 100 : null; // auto calculated

                  commit('SET_DOWNLOAD_DATA', state.siteInfoDetailChartOptions);
                }
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  // 年歷史
  getChartByYear: function getChartByYear(_ref6, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var state, commit, fId, siteName;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = _ref6.state, commit = _ref6.commit;
              fId = payload.fId, siteName = payload.siteName;
              _context5.next = 4;
              return getYearApi(fId, siteName).then(function (data) {
                var _data$data5;
                if (!(data !== null && data !== void 0 && (_data$data5 = data.data) !== null && _data$data5 !== void 0 && _data$data5.success)) {
                  state.resChoose = '年歷史';
                  state.resError = true;
                } else {
                  var _info$5;
                  state.resError = false;
                  state.showPR = true;

                  // get price from store
                  var info = mainStore.state.factoryInfo.filter(function (f) {
                    return f.factoryId === router.currentRoute.query.fid;
                  });
                  var unitPrice = (_info$5 = info[0]) === null || _info$5 === void 0 ? void 0 : _info$5.informations.unitPrice;
                  var price = 0;
                  if (unitPrice && unitPrice !== '-') {
                    price = unitPrice * 1;
                    state.showRevenue = true;
                  }

                  // 清空
                  commit('RESET_SITE_INFO_CHART');
                  // set yMax
                  commit('SET_YMAX', data === null || data === void 0 ? void 0 : data.data);

                  // data push
                  data.data.data = data === null || data === void 0 ? void 0 : data.data.data.sort(function (a, b) {
                    return a.year - b.year;
                  });
                  data.data.data.forEach(function (item) {
                    var time = item.year;
                    var acp = dbDataHandle(item.acp.all); // 發電量
                    var IRR = _typeof(item.IRR) === 'object' && item.IRR !== null ? dbDataHandle(item.IRR.avg) : dbDataHandle(item.IRR); // 日照量
                    var PVTemp = item.PVTemp > 0 ? dbDataHandle(item.PVTemp) : null;
                    // const PR = calculatePR(this.state.capacity, item.acp.all, IRR)
                    var PR = dbDataHandle(Math.floor(item.pr.all * 100));
                    var revenue = dbDataHandle(acp * price, 0);
                    state.siteInfoDetailChartOptions.xAxis[0].categories.push(time);
                    state.siteInfoDetailChartOptions.series[0].data.push(acp);
                    state.siteInfoDetailChartOptions.series[1].data.push(IRR);
                    state.siteInfoDetailChartOptions.series[2].data.push(PR);
                    state.siteInfoDetailChartOptions.series[3].data.push(PVTemp);
                    if (state.showRevenue) {
                      state.siteInfoDetailChartOptions.series[4].data.push(revenue);
                    }
                  });

                  // revenue Ymax
                  var revenueDataMax = Math.max.apply(Math, _toConsumableArray(state.siteInfoDetailChartOptions.series[4].data));
                  state.siteInfoDetailChartOptions.yAxis[4].max = revenueDataMax === 0 ? 100 : null; // auto calculated

                  commit('SET_DOWNLOAD_DATA', state.siteInfoDetailChartOptions);
                }
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  // 變流器歷史
  getChartByInvs: function getChartByInvs(_ref7, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var commit, date, invNum, fId, siteName;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref7.commit;
              date = payload.date, invNum = payload.invNum, fId = payload.fId, siteName = payload.siteName;
              _context6.next = 4;
              return getInvsApi(date, invNum, fId, siteName).then(function (data) {
                var _data$data6;
                if (!(data !== null && data !== void 0 && (_data$data6 = data.data) !== null && _data$data6 !== void 0 && _data$data6.success)) {
                  state.resChoose = '變流器歷史';
                  state.resError = true;
                } else {
                  var _info$6;
                  state.resError = false;
                  state.showPR = false;

                  // get price from store
                  var info = mainStore.state.factoryInfo.filter(function (f) {
                    return f.factoryId === router.currentRoute.query.fid;
                  });
                  var unitPrice = (_info$6 = info[0]) === null || _info$6 === void 0 ? void 0 : _info$6.informations.unitPrice;
                  var price = 0;
                  if (unitPrice && unitPrice !== '-') {
                    price = unitPrice * 1;
                    state.showRevenue = true;
                  }

                  // 清空
                  commit('RESET_SITE_INFO_CHART');
                  // set yMax
                  commit('SET_YMAX', data === null || data === void 0 ? void 0 : data.data);

                  // data push
                  data.data.data = data === null || data === void 0 ? void 0 : data.data.data.sort(function (a, b) {
                    return a.hhmm - b.hhmm;
                  });
                  data.data.data.forEach(function (item) {
                    var time = item.hhmm;
                    var acp = dbDataHandle(item.acp.all); // 發電量
                    var IRR = _typeof(item.IRR) === 'object' && item.IRR !== null ? dbDataHandle(item.IRR.avg) : dbDataHandle(item.IRR); // 日照量
                    var PVTemp = item.PVTemp > 0 ? dbDataHandle(item.PVTemp) : null; // 模組溫度
                    var revenue = dbDataHandle(acp * price, 0);
                    state.siteInfoDetailChartOptions.xAxis[0].categories.push(time);
                    state.siteInfoDetailChartOptions.series[0].data.push(acp);
                    state.siteInfoDetailChartOptions.series[1].data.push(IRR);
                    state.siteInfoDetailChartOptions.series[3].data.push(PVTemp);
                    if (state.showRevenue) {
                      state.siteInfoDetailChartOptions.series[4].data.push(revenue);
                    }
                  });

                  // revenue Ymax
                  var revenueDataMax = Math.max.apply(Math, _toConsumableArray(state.siteInfoDetailChartOptions.series[4].data));
                  state.siteInfoDetailChartOptions.yAxis[4].max = revenueDataMax === 0 ? 100 : null; // auto calculated

                  commit('SET_DOWNLOAD_DATA', state.siteInfoDetailChartOptions);
                }
              });
            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};